import { Injectable, Inject } from '@angular/core';
// import { NotificationsService } from '../notifications-module';

@Injectable()
export class MessageService {

  constructor(/*private notificationService: NotificationsService*/) { }


  // createErrorMessage(serv: ServicePlus): Observable<any> {
  //   let isRetrieve = serv.OperationName.includes('SER_RET') || serv.OperationName.includes('RET') ? true : false;
  //   let message = "Verifique los campos requeridos del formulario.";
  //   if (isRetrieve) {
  //     message = "Debe ingresar alguno de los siguientes campos: "
  //     let index = 0;
  //     for (let param of serv.Params) {
  //       if (!param.Evaluate(serv))
  //         message += " " + param.DisplayName + ",";
  //       index++;
  //     }
  //     return Observable.throw(message.replace(/.$/, "."))
  //   }
  //   return Observable.throw(message.replace(/.$/, "."));
  // }

//   showMessage(response) {
//     if (response.MessageType === MessageType.I)
//       this.notificationService.info('Información', response.Message, { id: response.MessageCode });
//     else if ((response.MessageType === MessageType.W))
//       this.notificationService.warn('Advertencia', response.Message, { id: response.MessageCode });
//     else if ((response.MessageType === MessageType.E))
//       this.notificationService.error('Error', response.Message, { id: response.MessageCode });
//     else
//       this.notificationService.success('Información', response.Message, { id: response.MessageCode });
//   }

//   success(message) {
//     this.notificationService.success('Información', message, { id: (Math.floor((Math.random() * 9000) + 1)) });
//   }

//   warning(message) {
//     this.notificationService.warn('Advertencia', message, { id: (Math.floor((Math.random() * 9000) + 1)) });
//   }

//   error(message) {
//     this.notificationService.error('Error', message, { id: (Math.floor((Math.random() * 9000) + 1)) })
//   }

}

// export enum MessageType {
//   I = 1,
//   W = 2,
//   E = 4,
//   S = 8
// }
